..
<template>
    <div class="form">
        <a-card :title="c_title">
            <v-gobackbutton slot="extra">返回</v-gobackbutton>
            <a-form-model :model="domainData" ref="ruleForm" :rules="rules" :layout="formItemLayout"
                          :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-form-model-item ref="uid" label="用户UID" prop="uid">
                    <span class="form_span">{{ domainData.uid }}</span>
                </a-form-model-item>

                <a-form-model-item ref="username" label="用户名称" prop="username">
                    <a-input v-model="domainData.username" @blur="
                        () => {
                            $refs.username.onFieldBlur();
                        }
                        "/>
                </a-form-model-item>
                <a-form-model-item ref="nickname" label="用户昵称" prop="nickname">
                    <a-input v-model="domainData.nickname" @blur="
                        () => {
                            $refs.nickname.onFieldBlur();
                        }
                        "/>
                </a-form-model-item>

                <a-form-model-item ref="userstate" label="用户状态" prop="userstate">
                    <a-radio-group v-model="domainData.userstate" button-style="solid" style="margin-left:15px">
                        <a-radio-button value="1"> 使用</a-radio-button>
                        <a-radio-button value="2"> 禁用</a-radio-button>
                    </a-radio-group>
                </a-form-model-item>

                <!-- 授权列表 -->
                <a-table :columns="columns1" :data-source="domainData.auths" :loading="tLoading"
                         :pagination="false"
                         rowKey="id">
                    <span slot="identitytype" slot-scope="text">{{ authMap[text] }}</span>
                    <template slot="operation" slot-scope="text, record">
                        <div class="editable-row-operations">
                            <span> <router-link
                                :to="{ path:'edituserauth', query: { uid: record.uid,identitytype:record.identitytype, identitykey: record.identitykey, username: domainData.username}}">编辑</router-link></span>
                        </div>
                    </template>
                </a-table>

                <a-form-model-item :wrapper-col="{ span: 8, offset: 12 }">
                    <a-button type="primary" @click="handleOk">
                        保存
                    </a-button>
                    <a-button style="margin-left: 10px;" @click="handleCancel">
                        取消
                    </a-button>
                </a-form-model-item>
            </a-form-model>
        </a-card>
    </div>
</template>

<script>
const m_title = {
    'edituser': '编辑用户'
};
const columns1 = [
    {
        title: '授权类型',
        dataIndex: 'identitytype',
        align: 'center',
        scopedSlots: {customRender: 'identitytype'},
        width: 150
    },
    {
        title: '账户名称',
        dataIndex: 'identitykey',
        align: 'center',
        width: 150
    },
    {
        title: '秘钥凭证',
        dataIndex: 'certificate',
        align: 'center',
        width: 150
    },
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width: 120,
        scopedSlots: {customRender: 'operation'},
    }
];
const authMap = {
    1: '账号密码',
    2: '手机号',
    3: '中伦网络公众号',
}
export default {
    data() {
        return {
            m_title,
            columns1,
            authMap,
            c_title: '',
            labelCol: {span: 6},
            wrapperCol: {span: 8},
            rules: {
                username: [
                    {required: true, message: '请输入用户名称', trigger: 'blur'},
                    {min: 1, max: 50, message: '请输入1~20个字符', trigger: 'blur'},
                ], nickname: [
                    {required: true, message: '请输入用户名称', trigger: 'blur'},
                    {min: 1, max: 50, message: '请输入1~20个字符', trigger: 'blur'},
                ],
            },
            confirmLoading: false,
            tLoading: false,
            formItemLayout: 'horizontal',
            domainData: {},
            selecterState: {
                isShow: false,
                rowsType: 'radio' // or 'checkbox'，单选或多选
            },
            is_vue_task: true,
        };
    },
    components: {},

    methods: {
        handleOk() {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.confirmLoading = true;
                    console.log(this.domainData);
                    // const {params} = this.$route;
                    //编辑
                    this.$store
                        .dispatch({
                            type: "ums/updateUser",
                            params: this.domainData
                        })
                        .then((response) => {
                            if (response.data.success == '1') {
                                console.log(response)
                                this.handleCancel()
                                this.confirmLoading = false;
                            }
                        });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },

        handleCancel() {
            this.resetForm();
            this.$router.back(-1);
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },
    },
    mounted() {
        const {query, params} = this.$route;
        this.c_title = m_title[params.action];
        let that = this;
        if (params.action != "adduser") {
            that.$store.dispatch({
                type: "ums/searchUserAndAuth",
                params: query
            }).then((res) => {
                console.log(res);
                that.tLoading = false;
                that.domainData = res.data.data

            })
        }

    }
};
</script>

<style lang="less" scoped>
.form_span {
    font-size: 14px;
    font-weight: bolder;
}
</style>
